<template>
<div>
  <div class="employee-search" v-if="!createdTrainingList">
    <loader-component></loader-component>
  </div>
  <div class="employee-search" v-else>
    <div class="px-2">
      <Input placeholder="Search for Training" type="text" v-model="trainingSearchTerm" />
    </div>
    <hr class="divider mt-2" />
    <div class="employee-list" v-if="createdTrainingList.length>0">
      <div
        :class="[
          'list-entity d-flex gap-2 justify-content-start align-items-center px-2 py-1',
          activeTraining == training.id ? 'active-training' : '',
        ]"
        v-for="(training, index) in createdTrainingList"
        :key="index"
        @click="handleTraining(training)"
      >
        <img :src="training.trainingImg" v-if="training.trainingImg" alt="" class="qb-avatar" />
         <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU" class="qb-avatar"/>
        <div>
          <p class="qb-entity-title" v-tooltip.top="training.name">
            {{ training.name }}
          </p>
          <p class="qb-entity-subtitle">Trainer : {{ training.trainerName }}</p>
        </div>
      </div>
    </div>
    <div v-else>
          <p class="text-center my-2">No Trainings Found</p>
    </div>
  </div>
</div>
</template>

<script>
import Input from "./TextFieldComponent.vue";
import LoaderComponent from "./LoaderComponent.vue"
import { createNamespacedHelpers } from "vuex";
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers("Training");
const { mapGetters: userMapGetters } = createNamespacedHelpers("Auth");

export default {
  name: "CreatedTrainingListComponent",
  data() {
    return {
      trainingSearchTerm: "",
      activeTraining: "",
    };
  },
  components: {
    Input,
    LoaderComponent
  },
  computed: {
    ...trainingMapGetters({
      createdTrainingList: "getCreatedTrainingList",
    }),
    ...userMapGetters({
      user: "getUser",
    }),
  },
  methods: {
    ...trainingMapActions({
      getCreatedTraining: "GET_CREATED_TRAINING_LIST",
      getUsersForEnrolledTraining: "GET_USERS_FOR_ENROLLED_TRAINING",
    }),
    structureData(data) {
      return data.replaceAll("_", " ");
    },
    handleTraining(training) {
      this.$router.push({
        name: "CreatedTrainingPage",
        query: {
          trainingId: training.id,
        },
      });
      this.activeTraining = training.id;
      this.getUsersForEnrolledTraining({ id: training.id });
    },
  },
  watch: {
    trainingSearchTerm() {
      this.getCreatedTraining({ userId: this.user.userId, name: this.trainingSearchTerm });
    },
    createdTrainingList() {
      if (this.createdTrainingList.length > 0 && this.activeTraining == "") {
        this.activeTraining = this.createdTrainingList[0].id;
        this.getUsersForEnrolledTraining({ id: this.createdTrainingList[0].id });
        this.$router.push({
          name: "CreatedTrainingPage",
          query: {
            trainingId: this.createdTrainingList[0].id,
          },
        });
      }
    },
  },

  created() {
    this.getCreatedTraining({ userId: this.user.userId });
    if (this.$route.query.trainingId) {
      this.activeTraining = this.$route.query.trainingId;
      this.getUsersForEnrolledTraining({ id: this.$route.query.trainingId });
    }
    // else {
    //   if (this.createdTrainingList.length > 0) {
    //     this.activeTraining = this.createdTrainingList[0].id;
    //     this.getUsersForEnrolledTraining({ id: this.createdTrainingList[0].id });
    //     this.$router.push({
    //       name: "CreatedTrainingPage",
    //       query: {
    //         trainingId: this.createdTrainingList[0].id,
    //       },
    //     });
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.employee-list {
  height: 380px;
  overflow-y: scroll;
}

.employee-list::-webkit-scrollbar {
  background: none;
  width: 5px;
}

.employee-list::-webkit-scrollbar-thumb {
  background-color: $light-300;
  border-radius: $field-border-radius;
}

// .employee-search {
//   max-height: 150px;
//   overflow: scroll;
// }

.qb-avatar {
  width: 60px;
  height: 35px;
  border-radius: 5px;
}

.active-training {
  background-color: #f1f1f1;
  border-left: 3px solid #1da8d5;
}

.qb-entity-title {
  color: $dark-200;
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin: 0px;

   text-overflow: ellipsis;
  display: block;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
}

.list-entity {
  border-bottom: 1px solid $light-200;

  &:hover {
    background-color: $light-100;
    cursor: pointer;
  }
}

.divider {
  border: 0.5px solid $light-500;
  margin: 0px;
}

.qb-entity-subtitle {
  color: $light-500;
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-1;
  margin: 0px;
}
</style>
